// Header right rail — thinking/design/toile_surfaces/Chrome.dc.html (`.si`, `.av`, `.dd`). Lifted
// from Toile's own `products/toile/components/UserBlock` (plan `2026_09_17_ovid_one_wall.md`) —
// class names kept literal from that file so a house that already shipped this exact markup
// (Toile) sees no change; `packsItem`/`divider` now serve any house's `extraLinks`, not only Packs.

.signIn {
    font-family: var(--tl-font);
    font-size: 12.5px;
    color: var(--tl-text);
    border: 1px solid var(--tl-border);
    border-radius: var(--tl-radius-pill);
    padding: 6px 16px;
    line-height: 1.4;
    white-space: nowrap;
    transition: border-color 150ms ease;

    &:hover {
        border-color: var(--tl-border-strong);
    }
}

.menu {
    position: relative;
    display: flex;
    align-items: center;
}

.avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: var(--tl-surface);
    border: 1px solid var(--tl-border-strong);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--tl-font);
    font-size: 12.5px;
    font-weight: 500;
    color: var(--tl-text);
    cursor: pointer;
    padding: 0;

    &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px color-mix(in srgb, var(--tl-accent) 18%, transparent);
    }
}

.dropdown {
    position: absolute;
    right: 0;
    top: 40px;
    width: 220px;
    background: var(--tl-surface);
    border: 1px solid var(--tl-border-strong);
    border-radius: var(--tl-radius-chrome-lg);
    padding: 8px;
    z-index: 2;
    box-shadow: 0 18px 48px color-mix(in srgb, var(--tl-shadow-ink) 50%, transparent);
}

// The menu's first extra link (Toile: Packs, plan 2026_09_04_wall_header_reveal.md § Step 3) —
// hidden above 640px: the shared `Header.module.scss` already carries a desktop `.nav` door at
// that width for a house that has one, so the two never show at once. `display: none` (not
// unmounted) keeps it in the DOM at every width.
// `.menuItem` — a row that stands at every width (`UserBlockExtraLink` without `phoneOnly`): the same
// dress, outside the fold below (an `@extend` would have carried the fold with it).
.packsItem,
.menuItem {
    display: block;
    font-family: var(--tl-font);
    font-size: 13px;
    color: var(--tl-muted);
    padding: 7px 10px;
    border-radius: var(--tl-radius-chrome-sm);

    &:hover {
        color: var(--tl-text);
        background: var(--tl-stage);
    }
}

.divider,
.rule {
    border: none;
    border-top: 1px solid var(--tl-border);
    margin: 4px 0;
}


// Above 640px (the shared `Header.module.scss`'s own threshold, named there too), a house with a
// desktop `.nav` already carries its extra link there — hide the menu's copy so no width shows the
// door twice.
@media (min-width: 641px) {
    .packsItem,
    .divider {
        display: none;
    }
}

.email {
    font-family: var(--tl-font-label);
    font-size: 10px;
    color: var(--tl-dim);
    padding: 6px 10px 8px;
    border-bottom: 1px solid var(--tl-border);
    margin: 0 0 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.item {
    display: block;
    width: 100%;
    text-align: left;
    font-family: var(--tl-font);
    font-size: 13px;
    color: var(--tl-muted);
    background: none;
    border: none;
    padding: 7px 10px;
    border-radius: var(--tl-radius-chrome-sm);
    cursor: pointer;

    &:hover {
        color: var(--tl-text);
        background: var(--tl-stage);
    }
}
